import React, { useEffect } from 'react';
import SplashScreen from '../components/SplashScreen';

const CHECKOUT_URL = 'https://buy.stripe.com/9B600ce30cGGdF63N2gQE03';

function CheckoutRedirect() {
  useEffect(() => {
    const timer = window.setTimeout(() => {
      window.location.replace(CHECKOUT_URL);
    }, 4000);

    return () => {
      window.clearTimeout(timer);
    };
  }, []);

  return (
    <main aria-label="Redirecting to checkout">
      <SplashScreen isLoading forceVisible />
    </main>
  );
}

export default CheckoutRedirect;
